




import $ from 'jquery';


const handleResponse = (figure, inputField) => response => {
    if ( response ) {
        const img = document.createElement('img');
        img.src = response;

        figure.append(img);

        inputField.value = response;
        figure.classList.add('has-img');
    }
};

const handleError = figure => response => {
    figure.innerHTML = response.responseText;
};

const removeImg = (elem, figure, inputField) => () => {
    figure.classList.remove('has-img');

    const img = figure.querySelector('img');
    if (img) img.remove();

    elem.querySelector('input.direct-file-upload').value = '';
    inputField.value = '';
};



const setupUpload = (elem) => {
    const figure = elem.querySelector('.upload-preview');

    if (!figure) return;

    const inputField = elem.querySelector('.ginput_container_text input');
    elem.querySelector('.delete').addEventListener('click', removeImg(elem, figure, inputField));

    elem.querySelectorAll('input.direct-file-upload')
        .forEach(input => {
            input.addEventListener('change', () => {
                if ( input.files.length > 0 ) {

                    const img = figure.querySelector('img');
                    if ( img ) img.remove();

                    figure.classList.add('loading');

                    inputField.value = '';

                    let formData = new FormData();                  
                    formData.append('file', input.files[0]);

                    $.ajax({
                        url: ylt.ajax_url + '?action=file_upload',
                        data: formData,
                        dataType: 'text',
                        contentType: false,
                        processData: false,
                        type: 'post',
                        success: handleResponse(figure, inputField),
                        complete: () => figure.classList.remove('loading'),
                        error: handleError(figure)
                    });
                }
            });
        });
};


export default function DirectFileUpload () {
    window.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.direct_file_upload')
            .forEach(elem => setupUpload(elem));
    });
}
